<!-- 
    Вікно підтвердження виходу з тікета

    Показується при натисканні "Залишити тікет".
    Якщо з тікета виходить саме той, хто почав тестування (whoStartedTest), 
    попереджаємо, що статус рішення повернеться на "Чекає на тестування" - 
    тікет знову стане в чергу на тест, навіть якщо в роботі лишились інші 
    співробітники (наприклад, розробник).
-->

<template>

    <dialogModal @close="this.$emit('close')">

        <template v-slot:title>
            {{ this.$t('leaveFromTicket') }}
        </template>

        <template v-slot:body>

            <div class="mt-4 text-center">
                <h4><b>{{ $t('confirmLeaveTicket') }}</b></h4>

                <!-- Виходить сам тестувальник - тікет повернеться в чергу на тестування -->
                <p v-if="isCurrentTester" class="text-muted fs-14 mt-3 mb-0">
                    {{ $t('leaveTicketTestingHint') }}
                </p>

                <!-- Виходить хтось інший (розробник), а тестування триває - статус не міняється -->
                <p v-else-if="isTestingByOther" class="text-muted fs-14 mt-3 mb-0">
                    {{ $t('leaveTicketTestingByOtherHint') }}
                </p>
            </div>

        </template>

        <template v-slot:footer-bottom>
            <button 
                type="button"
                class="btn link-success fw-medium" 
                @click="this.$emit('close')"
            >
                <i class="ri-close-line me-1 align-middle"></i> {{ $t('cancel') }}
            </button>
            <button 
                type="button" 
                class="btn btn-primary" 
                @click="this.$emit('confirmLeave')"
            >
                {{ this.$t('Confirm') }}
            </button>
        </template>

    </dialogModal>

</template>

<script>
import dialogModal from "@/components/modal/dialog.vue"
import { storeS } from "@/store" // глобальне сховище даних

export default {
    props: ['objCard'],
    components: {
        dialogModal
    },
    computed: {
        user(){
            return storeS.userbase
        },
        isTesting(){
            // Тікет зараз тестується
            return this.objCard && this.objCard.decidedStatus == 'intesting'
        },
        isCurrentTester(){
            // Тестування почав саме той, хто зараз виходить з тікета.
            // Для старих тікетів, де whoStartedTest ще не заповнений, вважаємо тестувальником
            // будь-кого з тих, хто взяв тікет в роботу - бек у такому разі теж відкотить статус
            if(!this.isTesting) {
                return false
            }

            if(this.objCard.whoStartedTest) {
                return this.objCard.whoStartedTest.workerId == this.user.userid
            }

            return Array.isArray(this.objCard.inJobWorkers)
                && this.objCard.inJobWorkers.some(el => el.workerId == this.user.userid)
        },
        isTestingByOther(){
            // Тікет тестує хтось інший - вихід не впливає на статус тестування
            return this.isTesting && !this.isCurrentTester
        }
    }
}
</script>
